<template>
  <div>
      <slot/>
      <ProposalFooter></ProposalFooter>
  </div>
</template>

<script>
import ProposalFooter from '@/desktop/widget/proposalFooter'
export default {
  name: 'App',
  components: {
    ProposalFooter
  },
  data () {
    return {
      policyNo: '',
      renewalNo: '',
      revisionNo: '',
      supplementNo: '',
      premium: 0,
      price: 0,
      // discountActive: false,
      startDate: '',
      endDate: '',
      productKey: '',
      coverageList: [],
      hasAsistans: false,
      isPrintAvailable: true,
      title: '',
      paymentResult: null
    }
  },
  mounted () {
    this.eventHub.eventHub.$emit('desktopActive', {
      value: true
    })
  },
  methods: {
    activateProposalInfo: function (obj) {
      var self = this
      self.policyNo = obj['policyNo']
      self.renewalNo = obj['']
      self.revisionNo = obj['']
      self.supplementNo = obj['']
      self.premium = obj['premium']
      self.exchangeType = obj['exchangeType']
      self.price = obj['price']
      // self.discountActive = obj['discountActive']
      self.startDate = obj['startDate']
      self.endDate = obj['endDate']
      self.productKey = obj['productKey']
      self.coverageList = obj['coverageList']
      self.hasAsistans = obj['hasAsistans']
      self.isPrintAvailable = obj['isPrintAvailable']
    },
    activatePayment: function (obj) {
      var self = this
      self.policyNo = obj['policyNo']
      self.premium = obj['premium']
      self.productKey = obj['productKey']
      self.startDate = obj['startDate']
      self.endDate = obj['endDate']
    },
    activatePaymentResult: function (obj) {
      var self = this
      self.title = obj['title']
      self.paymentResult = obj['paymentResult']

      self.productKey = obj['productKey']
      self.policyNo = obj['policyNo']
      self.revisionNo = obj['revisionNo']
    }
  },
  created: function () {
    this.eventHub.$on('show-proposalInfo', this.activateProposalInfo)
    this.eventHub.$on('show-payment', this.activatePayment)
    this.eventHub.$on('show-payment-result', this.activatePaymentResult)
  },
  beforeDestroy: function () {
    this.eventHub.$off('show-proposalInfo', this.activateProposalInfo)
    this.eventHub.$off('show-payment', this.activatePayment)
    this.eventHub.$off('show-payment-result', this.activatePaymentResult)
    Object.assign(this.$data, this.$options.data())
  }
}
window.onload = function () {
  window.scrollTo(0, 0)
}
</script>



// WEBPACK FOOTER //
// src/desktop/template/ProposalTemplate.vue